module.exports = __webpack_public_path__ + "static/img/no-images.203b975.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-images.jpg
// module id = 7CXA
// module chunks = 1